import { useSuspenseQuery } from "@tanstack/react-query";
import { type CompletionStatusType } from "@utils/completion_status";

export type Task = {
  id: number;
  taskable_type: string;
  status: CompletionStatusType;
};

const fetchTasks = async (): Promise<Task[]> => {
  const response = await fetch("/tasks.json");
  return response.json();
};

export default function useTasks() {
  return useSuspenseQuery<Task[]>({
    queryKey: ["tasks"],
    queryFn: fetchTasks,
    staleTime: 0,
    refetchOnMount: true,
  });
}
